// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Cpsc","buttons":"PendingPaymentAlert_buttons__1yqqk"};